import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Overview from './Overview';
import NavBar from "./Components/NavBar"
import VenueListing from "./Components/VenueListing"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import SingleVenue from "./Components/SingleVenue"


function App() {
  return (
    <React.Fragment>
      <NavBar/>
      <Switch>
        <Route exact path="/" component={Overview} />
        <Route exact path="/venues" component={VenueListing} />
        <Route exact path="/venues/:slug" component={SingleVenue} />
      </Switch>
    </React.Fragment>
  );
}

export default App;